<div class="refund-btn" *ngIf="!isRefunded && canRefund">
  <wm-common-button
    [data]="{
      text: 'REFUND'
    }"
    (click)="openRefundConfirmation($event)"
  ></wm-common-button>
</div>

<span *ngIf="isRefunded">
  Refunded
</span>

<div class="modal-confirm">
  <wm-common-confirmation-modal
    [data]="confirmationModal"
    (onYesClick)="confirmRefund()"
    (onNoClick)="cancelRefund()"
  >
    <wm-common-text
      [data]="{
        text: 'This will only mark the payment as refunded. You will still need to refund the payment manually in the source payment system.'
      }"
    ></wm-common-text>
  </wm-common-confirmation-modal>
</div>
